<template>
  <el-dialog
    :title="form.id ? $t('text.edit_round') : $t('text.add_round')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="500px"
    class="add-round"
  >
    <div>
      <el-form :model="form" ref="form" :rules="rules" label-width="70px">
        <el-form-item prop="name" :label="$t('text.name')">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="round" :label="$t('text.range')">
          <el-time-picker
            is-range
            v-model="form.round"
            :range-separator="$t('text.to').toLowerCase()"
            :start-placeholder="$t('text.start')"
            :end-placeholder="$t('text.end')"
            class="wp-100"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{
          form.id ? $t('text.save').toUpperCase() : $t('text.add').toUpperCase()
        }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import moment from 'moment'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        id: 0,
        name: '',
        round: [moment().startOf('day'), moment().endOf('day')]
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('text.please_enter_name')
          }
        ],
        round: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('text.please_select_range')
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        round: [moment().startOf('day'), moment().endOf('day')]
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleSave()
        }
      })
    },
    getParams() {
      let params = {
        ShiftName: this.form.name,
        ShiftStart: moment(this.form.round[0]).format('HH:mm:ss'),
        ShiftEnd: moment(this.form.round[1]).format('HH:mm:ss'),
        OrganisationId: this.$store.getters[`filter/calculatedFilter`]
          .organisationId
      }
      if (this.form.id) {
        params.id = this.form.id
      }
      return params
    },
    handleSave() {
      this.loading = true
      ApiService.SaveOrganisationShift(this.getParams())
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.closeDialog()
            this.$parent.getRounds()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed')
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.add-round {
  .el-date-editor .el-range-separator {
    width: 10%;
  }
}
</style>
